import type { MouseEvent, ReactNode } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import { useColorScheme } from "@mui/material/styles";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import SettingsBrightnessOutlinedIcon from "@mui/icons-material/SettingsBrightnessOutlined";

type ColorSchemeMode = "light" | "system" | "dark";

const MODES: { mode: ColorSchemeMode; label: string; icon: ReactNode }[] = [
  { mode: "light", label: "Light", icon: <LightModeOutlinedIcon fontSize="small" /> },
  { mode: "system", label: "Match the computer", icon: <SettingsBrightnessOutlinedIcon fontSize="small" /> },
  { mode: "dark", label: "Dark", icon: <DarkModeOutlinedIcon fontSize="small" /> },
];

/** The light / system / dark switch at the bottom of the side menu; MUI remembers the choice. */
export const SideMenuColorScheme = () => {
  const colorScheme = useColorScheme();
  const mode = colorScheme.mode ?? "system";

  const handleChange = (_event: MouseEvent<HTMLElement>, next: ColorSchemeMode | null) => {
    if (next) colorScheme.setMode(next);
  };

  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      onChange={handleChange}
      size="small"
      value={mode}
    >
      {MODES.map((item) => (
        <Tooltip
          key={item.mode}
          title={item.label}
        >
          <ToggleButton
            aria-label={item.label}
            value={item.mode}
          >
            {item.icon}
          </ToggleButton>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  );
};
